<template>
  <!-- メール作成画面 -->
  <div v-if="step==0">
    <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-email" style="margin-right: 8px;"></span>メール送付<template v-if="sendEmailTemplate.seeker_name"><span class="seeker-name-highlight">{{sendEmailTemplate.seeker_name}}様</span></template></h2>
    <div style="display: flex; align-items: center; margin-bottom: 8px;">
      <p style="text-align: left; font-size: smaller; width: 150px;"><span class="mdi mdi-note-text" style="margin-right: 8px;"></span>メールテンプレート</p>
      <select v-model="templateIndex" class="select is-small" style="width: calc(100% - 176px); margin-right: 8px;">
        <option :value="i" v-for="(t, i) in emailTemplates" :key="i + '-template'">
          {{t.name}}
        </option>
      </select>
    </div>
    <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">FROM:</p>
      <input class="input is-small" v-model="sendEmailTemplate.from_email" @input="onInputChange"/>
    </div>
    <div v-if="!bulk" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">TO:</p>
      <input class="input is-small" v-model="sendEmailTemplate.to_email" @input="onInputChange"/>
    </div>
    <div v-else style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600; font-size: smaller;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">TO:</p><span>チェック済みのユーザー全員に送付します。</span>
    </div>
    <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">CC:</p>
      <input class="input is-small" v-model="sendEmailTemplate.cc_email" @input="onInputChange"/>
    </div>
    <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">件名:</p>
      <input class="input is-small" v-model="sendEmailTemplate.title" @input="onInputChange"/>
    </div>
    <quill-editor class="mail-box" v-model="sendEmailTemplate.template" ref="quillEditor" :options="options" v-if="emailTemplates.length > 0" @input="onInputChange"></quill-editor>
    <button
      v-if="isSaveButton"
      @click="tempSaveEmail(bulk)"
      class="button is-small is-fullwidth"
      style="margin-top: 8px;">
      <span class="mdi" style="margin-right: 8px;"></span>一時保存する
    </button>

    <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600; font-size: smaller;" v-if="bulk===true">
      <span style="color:red;">※メール一括送付の場合は、確認画面を経由せずに直接送信します。</span>
    </div>
    <button @click="confirmEmailToSeeker()"
      v-if="bulk===false"
      class="button is-primary is-small is-fullwidth"
      :class="{'is-loading': sendLoadding}"
      style="margin-top: 8px;">
      <span class="mdi mdi-email" style="margin-right: 8px;"></span>メール内容を確認
    </button>
    <!-- 内容を確定し、メールを送付する -->
    <button @click="sendBulkEmailToSeeker(date)"
      v-else
      class="button is-primary is-small is-fullwidth"
      :class="{'is-loading': sendLoadding}"
      style="margin-top: 8px;">
      <span class="mdi mdi-email" style="margin-right: 8px;"></span>メールを送る
    </button>

    <div v-if="isLinkMenu">
      <template class="disp-scroll">
        <div style="display: flex; align-items: center; margin-top: 8px;">
          <p style="text-align: left; font-size: smaller; width: 150px;"><span class="mdi mdi-robot" style="margin-right: 8px;"></span>ロボリンク</p>
          <select v-model="sendEmailTemplate.robo" class="select is-small" style="width: calc(100% - 176px); margin-right: 8px;">
            <template v-for="(c, i) in isConfirmChatbot(chatbots)">
              <option :key="i + '-tempbot'" :value="c.bot_id" v-if="!c.is_archive">
                {{c.name}}
              </option>
            </template>
          </select>
          <button class="button is-small" style="border-radius: 4px;" @click="helpMessage('__robo_url__とメール本文に挿入することで自動的に設定されたロボのリンクが作成されます。')">
            <span class="mdi mdi-help-circle-outline"></span>
          </button>
        </div>
        <div style="display: flex; align-items: center; margin-top: 8px;">
          <p style="text-align: left; font-size: smaller; width: 150px;"><span class="mdi mdi-message-video" style="margin-right: 8px;"></span>Web会議リンク</p>
          <select v-model="sendEmailTemplate.video_user" class="select is-small" style="width: calc(100% - 176px); margin-right: 8px;">
            <template v-for="(u, i) in showUsers">
              <option :key="i + '-tempuser'" :value="u.user_hash">
                {{u.username}}
              </option>
            </template>
          </select>
          <button class="button is-small" style="border-radius: 4px;" @click="helpMessage('__video_url__とメール本文に挿入することで自動的に設定されたWeb会議のリンクが作成されます。')">
            <span class="mdi mdi-help-circle-outline"></span>
          </button>
        </div>
        <div style="display: flex; align-items: center; margin-top: 8px;">
          <p style="text-align: left; font-size: smaller; width: 150px;"><span class="mdi mdi-file-video" style="margin-right: 8px;"></span>録画面接リンク</p>
          <select v-model="sendEmailTemplate.record" class="select is-small" style="width: calc(100% - 176px); margin-right: 8px;">
            <template v-for="(r, i) in recordingInterviews">
              <option :key="i + '-temprecord'" :value="r.id">
                {{r.name}}
              </option>
            </template>
          </select>
          <button class="button is-small" style="border-radius: 4px;" @click="helpMessage('__record_url__とメール本文に挿入することで自動的に設定された録画面接のリンクが作成されます。')">
            <span class="mdi mdi-help-circle-outline"></span>
          </button>
        </div>
      </template>
    </div>
    <!-- 置換説明の表示切り替え -->
    <div v-if="isReplaceExplanation">
      <template>
        <div class="desc">
          <p class="comment">(※1) <span style="font-weight: bold">__applicant__</span>と入力すると訪問者のお名前に沿って変換されます。</p>
          <p class="comment">(※2) <span style="font-weight: bold">__date_modify__</span>とメール内容に入力すると日程自動調整で設定されていた場合に訪問者向け日程変更リンクに変換されます。</p>
          <p class="comment">(※3) ロボリンクに指定したロボにミニロボが設定されている場合、応募者のカスタムカラムにミニロボ名が設定されている場合にのみ、変換が可能です。</p>
          <p class="comment">(※4) <span style="font-weight: bold">__received_form__</span>とメール内容に入力すると返信用フォームのリンクに変換されます。</p>
          <p class="comment">(※5) <span style="font-weight: bold">__カスタムカラム名__</span>とメール内容に入力するとカスタムカラムの内容に変換されます。
          <!-- __meeting_date__の表示切り替え -->
          <div style="display: flex" v-if="isMeetingDate">
            <p class="comment">(※6) </p>
            <div>
              <p><span style="font-weight: bold">__meeting_date__</span>と入力していただくと前ページで設定した面接日時</p>
              <p>{{`「${date.start_date_and_time} ~ ${date.end_date_and_time}」`}}</p>
              <p>が反映されます。</p>
            </div>
          </div>
          <!-- __line_code__の表示切り替え -->
          <div style="display: flex" v-if="hasLineChannel">
            <p class="comment">(※7) </p>
            <div>
              <p><span style="font-weight: bold">__line_code__</span>とメール内容に入力するとLINE連携コードに変換されます。</p>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

  <!-- メール内容の確認画面 -->
  <div v-else-if="step==1">
    <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-email" style="margin-right: 8px;"></span>メール内容確認<template v-if="sendEmailTemplate.seeker_name"><span class="seeker-name-highlight">{{sendEmailTemplate.seeker_name}}様</span></template></h2>
    <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">FROM:</p>
      <p style="margin-right: 4px; font-size: smaller; is-fullwidth; text-align: left;">{{sendEmailTemplate.from_email}}</p>
    </div>
    <div v-if="!bulk" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">TO:</p>
      <p style="margin-right: 4px; font-size: smaller; is-fullwidth; text-align: left;">{{sendEmailTemplate.to_email}}</p>
    </div>
    <div v-else style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600; font-size: smaller;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">TO:</p><span>チェック済みのユーザー全員に送付します。</span>
    </div>
    <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">CC:</p>
      <p style="margin-right: 4px; font-size: smaller; is-fullwidth; text-align: left;">{{sendEmailTemplate.cc_email}}</p>
    </div>
    <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">件名:</p>
      <p style="margin-right: 4px; font-size: smaller; is-fullwidth; text-align: left;">{{sendEmailTemplate.title}}</p>
    </div>
    <section class="detail-message">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">本文:</p>
      <div class="message-container disp-scroll">
        <h2 v-html="sendEmailTemplate.content.replace(/\n/g,'<br/>')"></h2>
      </div>
    </section>

    <button
      v-if="isSaveButton"
      @click="step=0"
      class="button is-small is-fullwidth"
      style="margin-top: 8px;">
      <span class="mdi" style="margin-right: 8px;"></span>入力画面に戻る
    </button>

    <!-- 内容を確定し、メールを送付する -->
    <button @click="sendEmailToSeeker(date)"
      class="button is-primary is-small is-fullwidth"
      :class="{'is-loading': sendLoadding}"
      style="margin-top: 8px;">
      <span class="mdi mdi-email" style="margin-right: 8px;"></span>メールを送る
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isOpenEmailMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    bulk: {
      type: Boolean,
      required: true
    },
    chatbots: {
      type: Array,
      required: true
    },
    recordingInterviews: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    sendLoadding: {
      type: Boolean,
      required: true
    },
    emailTemplates: {
      type: Array,
      required: true
    },
    sendEmailTemplate: {
      type: Object,
      required: false
    },
    changeEmailTemplate: {
      type: Function,
      required: true
    },
    sendEmailToSeeker: {
      type: Function,
      required: true
    },
    copyLink: {
      type: Function,
      required: true
    },
    tempSaveEmail: {
      type: Function,
      required: true
    },
    helpMessage: {
      type: Function,
      required: true
    },
    isSaveButton: {
      type: Boolean,
      default: true,
      required: false
    },
    isLinkMenu: {
      type: Boolean,
      default: false,
      required: false
    },
    isReplaceExplanation: {
      type: Boolean,
      default: false,
      required: false
    },
    isMeetingDate: {
      type:Boolean,
      default: true,
      require: false
    },
    date: {
      type: Object,
      default: null,
      required: false
    },
  },
  data() {
    return {
      templateIndex: 0,
      step: 0,
      contentText: [],
      isEditing: false  // 編集中かどうかを追跡する変数を追加
    };
  },
  computed: {
    ...mapGetters('auth', ['hasLineChannel']),
    showUsers () {
        // ログイン不可ユーザーを表示しない
        return this.users.filter(user => {return user.permission < 3})
    },
  },
  watch: {
    isOpenEmailMenu() {
      if (this.isOpenEmailMenu === false) {
        this.templateIndex = 0
        this.isEditing = false
        this.$emit('update:editing', false)
      }
    },
    templateIndex() {
      if (this.isOpenEmailMenu === true) {
        this.changeEmailTemplate(this.templateIndex)
        // テンプレート選択時は編集状態にしない
        this.isEditing = false
        this.$emit('update:editing', false)
      }
    }
  },
  methods: {
    // 編集状態を設定するメソッド
    setEditing(isEditing) {
      if (this.isEditing !== isEditing) {
        this.isEditing = isEditing
        this.$emit('update:editing', isEditing)
      }
    },
    // フォーム変更時の処理
    onInputChange() {
      this.setEditing(true)
    },
    isConfirmChatbot (chatbots) {
      let confirmChatbots = []
      for (const c of chatbots) {
        if (c.is_confirm) {
          confirmChatbots.push(c)
        }
      }
      return confirmChatbots
    },
    confirmEmailToSeeker (){
      if (this.sendEmailTemplate.from_email === '') {
        alert('FROMにメールアドレスを設定してください。')
        return
      }
      if (this.sendEmailTemplate.to_email === '') {
        alert('TOにメールアドレスを設定してください。')
        return
      }
      this.sendEmailTemplate.confirmFlg = 1
      this.sendEmailTemplate.meeting_date = this.date
      this.$store.dispatch('directtalk/sendEmailToSeeker', this.sendEmailTemplate)
        .then((d) => {
          if (d.data.error_result_list.length > 0) {
            // エラーがある場合
            let errer_list = []
            for (const error of d.data.error_result_list) {
              errer_list.push('・' + error.seeker_email + ' (' + error.seeker_name + ')：[' + error.status + ']')
            }
            alert('以下のエラーが発生しました。\n\n' + errer_list.join('\n'))
          } else {
            this.contentText = d.data.content
            this.sendEmailTemplate.content = this.contentText
            this.sendEmailTemplate.confirmFlg = 0
            this.step = 1
          }
        })
    },
    sendBulkEmailToSeeker (date) {
      if (this.sendEmailTemplate.from_email === '') {
        alert('FROMにメールアドレスを設定してください。')
        return
      }
      this.sendEmailTemplate.confirmFlg = 0
      this.sendEmailToSeeker(date)
    }
  }
};
</script>

<style scoped lang="scss">
.seeker-name-highlight {
  background-color: #f0f8ff;
  color: #AA0066;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #e1e8ed;
  display: inline-block;
  margin-left: 4px;
}
</style>
.mail-box {
  height: calc(95% - 400px);
}
.desc {
  margin-top: 16px;
  p {
    font-size: 14px;
    text-align: left;
    color: gray;
  }
}
.detail-message {
  margin-top: 16px;

  .message-container {
    padding: 8px;
    margin-top: 8px;
    height: 400px;
    text-align: left;
    font-size: smaller;
    border: 1px solid gray;
  }
}
.comment {
  text-align: left;
  color: grey;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/emails/MailActionContent.vue